/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimBalanceSurchargeResponse
 */
export interface ClaimBalanceSurchargeResponse {
    /**
     * 
     * @type {number}
     * @memberof ClaimBalanceSurchargeResponse
     */
    affectedClaimCount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimBalanceSurchargeResponse
     */
    previousTotal: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimBalanceSurchargeResponse
     */
    newTotal: number;
}

/**
 * Check if a given object implements the ClaimBalanceSurchargeResponse interface.
 */
export function instanceOfClaimBalanceSurchargeResponse(value: object): value is ClaimBalanceSurchargeResponse {
    if (!('affectedClaimCount' in value) || value['affectedClaimCount'] === undefined) return false;
    if (!('previousTotal' in value) || value['previousTotal'] === undefined) return false;
    if (!('newTotal' in value) || value['newTotal'] === undefined) return false;
    return true;
}

export function ClaimBalanceSurchargeResponseFromJSON(json: any): ClaimBalanceSurchargeResponse {
    return ClaimBalanceSurchargeResponseFromJSONTyped(json, false);
}

export function ClaimBalanceSurchargeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimBalanceSurchargeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'affectedClaimCount': json['affectedClaimCount'],
        'previousTotal': json['previousTotal'],
        'newTotal': json['newTotal'],
    };
}

export function ClaimBalanceSurchargeResponseToJSON(json: any): ClaimBalanceSurchargeResponse {
    return ClaimBalanceSurchargeResponseToJSONTyped(json, false);
}

export function ClaimBalanceSurchargeResponseToJSONTyped(value?: ClaimBalanceSurchargeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'affectedClaimCount': value['affectedClaimCount'],
        'previousTotal': value['previousTotal'],
        'newTotal': value['newTotal'],
    };
}

